// extracted by mini-css-extract-plugin
export default {"input":"Dimension_input__PQ5El"};